import { ContactSupportContent } from "@/app/services/context/ContactSupportContent";
import { useToken } from "@/app/services/context/TokenContext";
import { DATA_GIF_PATH, ICON_BASE_PATH } from "@/app/utils/config";
import { redirectToGrowXLogout } from "@/app/utils/loginservice/redirectToGrowXLogout";

const RequestRejected = () => {
  const { logout } = useToken();

  // ........................................handleLogout.............................
  const handleLogout = () => {
    setTimeout(redirectToGrowXLogout, 0);
    logout();
  };

  return (
    <div className="gx-smeonboard-card">
      <div className="gx-handlerequestagain-box">
        <div className="gx-smeonboard-box">
          <div className="gx-CompanyIdVerity-box">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <div className="gx-login-error-img">
                  <img
                    src={`${DATA_GIF_PATH}reject_animation.gif`}
                    alt="Success"
                  />
                </div>
              </div>
              <div className="col-span-12">
                <div className="gx-request-progress-title">
                  <h2 className="gx-h2-l">
                    Request <span className="gx-h2-b">Rejected</span>
                  </h2>
                  <p>
                    Your onboarding request was not approved by GrowX
                    administrator.Please contact themfor assistance.
                  </p>
                </div>
              </div>

              <div className="col-span-12">
                <div className="growx-company-box">
                  <p>
                    <img
                      className="growx-info-img"
                      src={`${ICON_BASE_PATH}info_icon_sky_blue.svg`}
                    />
                    Your account has been deactivated. Please contact GrowX
                    Support for assistance.
                  </p>
                  <ContactSupportContent variant="inline" />
                </div>
              </div>

              <div className="col-span-12">
                <div className="gx-connectbank-logout">
                  <button onClick={handleLogout}>
                    <img src={`${ICON_BASE_PATH}logouticon.svg`} alt="name" />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RequestRejected;
